import { Metamodel } from '../base/model';
import { IAttribute, IModel } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { adfModelTypeMap } from '../../registries/consts/adf-model-type-map-const';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.sapOdp.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.SapOdp_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.SapOdp_DisplayText)
    ]
})
export class SapOdpLinkedService extends LinkedService {
    public static readonly MODEL: IModel;

    public static readonly SERVER: IAttribute;
    public static readonly SYSTEM_NUMBER: IAttribute;
    public static readonly CLIENT_ID: IAttribute;
    public static readonly LANGUAGE: IAttribute;
    public static readonly SNC_MY_NAME: IAttribute;
    public static readonly SNC_PARTNER_NAME: IAttribute;
    public static readonly SNC_LIBRARY_PATH: IAttribute;
    public static readonly SNC_QOP: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly SUBSCRIBER_NAME: IAttribute;
    public static readonly X509_CERTIFICATE_PATH: IAttribute;
    public static readonly PASSWORD: IAttribute;
    public static readonly MESSAGE_SERVER: IAttribute;
    public static readonly MESSAGE_SERVER_SERVICE: IAttribute;
    public static readonly SYSTEM_ID: IAttribute;
    public static readonly LOGON_GROUP: IAttribute;
    public static readonly IS_SSO: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host,
        association: 'SERVER',
        templatable: true
    })
    public server?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port,
        association: 'SYSTEM_NUMBER',
        templatable: true
    })
    public systemNumber?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Sid,
        association: 'CLIENT_ID',
        templatable: true
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: stringResources.Language,
        association: 'LANGUAGE',
        templatable: true
    })
    public language?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_SncMode
    })
    public sncMode?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_SncMyName,
        association: 'SNC_MY_NAME',
        templatable: true
    })
    public sncMyName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_SncPartnerName,
        association: 'SNC_PARTNER_NAME',
        templatable: true
    })
    public sncPartnerName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_SncLibraryPath,
        association: 'SNC_LIBRARY_PATH',
        templatable: true
    })
    public sncLibraryPath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_SncQop,
        association: 'SNC_QOP',
        templatable: true
    })
    public sncQop?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_SubscriberName,
        association: 'SUBSCRIBER_NAME',
        templatable: true
    })
    public subscriberName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_X509CertificatePath,
        association: 'X509_CERTIFICATE_PATH',
        templatable: true
    })
    public x509CertificatePath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'PASSWORD',
        templatable: true
    })
    public password?: string | AzureKeyVault;

    public logonType: 'applicationServer' | 'group' = 'applicationServer'; // ui only

    @Metamodel.attribute({
        display: stringResources.ModelName_MessageServer,
        association: 'MESSAGE_SERVER',
        templatable: true
    })
    public messageServer?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_MessageServerService,
        association: 'MESSAGE_SERVER_SERVICE',
        templatable: true
    })
    public messageServerService?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_SystemId,
        association: 'SYSTEM_ID',
        templatable: true
    })
    public systemId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_LogonGroup,
        association: 'LOGON_GROUP',
        templatable: true
    })
    public logonGroup?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_IsSSO,
        association: 'IS_SSO',
        templatable: true
    })
    public isSSO?: boolean = true;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
